import { render, staticRenderFns } from "./lucroSideBar.vue?vue&type=template&id=1291eaa2"
import script from "./lucroSideBar.vue?vue&type=script&lang=js"
export * from "./lucroSideBar.vue?vue&type=script&lang=js"
import style0 from "./lucroSideBar.vue?vue&type=style&index=0&id=1291eaa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports